<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <v-row>
                        <v-col>
                            <v-card class="pa-2">
                                <h1 class="text-primary">Olete sisenenud Kriminaalhooldusportaali!</h1>
                                <p class="mt-3">
                                    Kriminaalhooldusportaali eesmärgiks on toetada Teie kriminaalhoolduse
                                    läbimist.
                                    Kriminaalhooldusega seotud informatsioon on koondunud siia ning täieneb
                                    pidevalt. Saate iseseivalt, endale sobival ajal tutvuda dokumentidega ja
                                    kõige
                                    muuga, mis kriminaalhooldust puudutab. Tegemist on Teie isikliku virtuaalse
                                    toimikuga.
                                </p>
                                <p class="mt-3">
                                    Kui avalehe paremale poolele ilmub punase hüüumärgiga kastike, toimige
                                    vastavalt
                                    juhistele – ametnik soovib Teile olulist informatsiooni edastada või anda
                                    vajaliku juhise.
                                </p>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <VoHoiatus class="ma-2"></VoHoiatus>
                        </v-col>
                    </v-row>
                    <v-row class="d-xl-none">
                        <v-col>
                            <MinuAmetnik></MinuAmetnik>
                        </v-col>
                    </v-row>
                    <v-row class="d-xl-none">
                        <v-col>
                            <TahelepanuTeavitused></TahelepanuTeavitused>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h1 class="px-2">Planeeritud kohtumised ja tegevused</h1>
                            <p class="px-2 text-textDark text-justify mt-3">Siit leiate kiire ülevaate järgmisest
                                registreerimise ajast, sellega seotud kokkulepetest ning teistest planeeritud
                                tegevustest.
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <PlaneeritudKohtumisedTegevused></PlaneeritudKohtumisedTegevused>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="d-none d-xl-block makslaius" cols="auto" >
                    <v-row>
                        <v-col>
                            <MinuAmetnik></MinuAmetnik>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <TahelepanuTeavitused></TahelepanuTeavitused>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>

<style scoped>
.makslaius {
    max-width: 350px;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import MinuAmetnik from './uldine/MinuAmetnik.vue';
import TahelepanuTeavitused from './uldine/TahelepanuTeavitused.vue';
import PlaneeritudKohtumisedTegevused from './PlaneeritudKohtumisedTegevused.vue';

export default defineComponent({
    name: 'AvaLeht',
    components: {
        KRHPPaigutus,
        MinuAmetnik,
        TahelepanuTeavitused,
        PlaneeritudKohtumisedTegevused
    },
});
</script>